import { createContext } from 'react'

import { IModalBaseContextProps } from './types'

export const ModalBaseContext = createContext({} as IModalBaseContextProps)
